export default ({ store, route, redirect, req }) => {
  const auth = { ...store.state.authModule }
  if (process.server && req.token) return
  if (auth.user) return
  redirect(
    `/?openLoginModal=true&target=${route.path}&time=${new Date().getTime()}`
  )
}
